// Shared state outside React
export const eventStoreTrigger = { value: 0 } as { value: number; forceUpdate: () => void };
